<template>
  <div class="login-impl">
    <login-panel class="login-panel"/>
    <div class="copyright">
      大连金力得科技发展有限公司<br>
      Copyright@2020 Amazon4Sellers Team. All rights reserved.
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import LoginPanel from './LoginPanel'

@Component({
  components: {LoginPanel}
})
export default class Login extends Vue {
}
</script>
<style scoped lang="scss">
  .login-impl {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #d4dce5;

    .login-panel {
      z-index: 1;
      width: 430px;
      height: 480px;
      margin-bottom: 10%;
    }

    .copyright {
      position: absolute;
      bottom: 20px;
    }
  }
</style>
